type CheckCircleIconProps = {
  className?: string;
  width?: string | number;
  height?: string | number;
};

export const CheckCircleIcon = (props: CheckCircleIconProps) => (
  <svg
    width="176"
    height="176"
    viewBox="0 0 176 176"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="88" cy="88" r="84" fill="#00008F" stroke="#00008F" strokeWidth="7.5" />
    <path d="M41.5 90.0301L74.1634 118L134.5 58" stroke="white" strokeWidth="6" />
  </svg>
);
